module.exports = __webpack_public_path__ + "img/logo.bd67fac9.png";